import React, { useEffect } from 'react'
import useExecScripts from '../Component/useExecScripts'
import EnquiryForm from '../Component/EnquiryForm'
import EnquiryHeading from '../Component/EnquiryHeading'

function DeliveryServices() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const containerRef = useExecScripts();

	return (
		<div id="content" className="site-content">
			<div className="ast-container">
				<div id="primary" className="content-area primary">
					<main id="main" className="site-main">
						<article className="page type-page status-publish ast-article-single">
							<header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
							<div ref={containerRef}>
								<div className="entry-content clear" itemProp="text">


									<div data-elementor-type="wp-page" data-elementor-id="3063" className="elementor elementor-3063">
										<div className="elementor-element elementor-element-3b69b429 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="3b69b429" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-c8cebcb e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="c8cebcb" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-4eb76c49 elementor-widget__width-inherit elementor-widget elementor-widget-elementskit-heading" data-id="4eb76c49" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Planning a house party for</h2><h2 className="ekit-heading--subtitle elementskit-section-subtitle  ">
															4 to 50 guests?
														</h2></div></div>				</div>
												</div>
												<div className="elementor-element elementor-element-a62244b elementor-widget__width-inherit elementor-widget elementor-widget-elementskit-heading" data-id="a62244b" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Zomato and Swiggy getting expensive?</h2><h2 className="ekit-heading--subtitle elementskit-section-subtitle  ">
															And Caterers unwilling to serve small guest counts?
														</h2></div></div>				</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-7f208e4a e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="7f208e4a" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-14ea629d elementor-widget__width-inherit elementor-widget elementor-widget-elementskit-heading" data-id="14ea629d" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">For the first time in Pune</h2></div></div>				</div>
												</div>
												<div className="elementor-element elementor-element-2a02451a elementor-widget elementor-widget-image" data-id="2a02451a" data-element_type="widget" data-e-type="widget" data-widget_type="image.default">
													<div className="elementor-widget-container">
														<img decoding="async" width="1600" height="608" src="/assets/images/05/WhatsApp-Image-2025-05-08-at-12.04.30-PM.jpeg" className="attachment-2048x2048 size-2048x2048 wp-image-3233" alt="" srcSet="/assets/images/05/WhatsApp-Image-2025-05-08-at-12.04.30-PM.jpeg 1600w, /assets/images/05/WhatsApp-Image-2025-05-08-at-12.04.30-PM-300x114.jpeg 300w, /assets/images/05/WhatsApp-Image-2025-05-08-at-12.04.30-PM-1024x389.jpeg 1024w, /assets/images/05/WhatsApp-Image-2025-05-08-at-12.04.30-PM-768x292.jpeg 768w, /assets/images/05/WhatsApp-Image-2025-05-08-at-12.04.30-PM-1536x584.jpeg 1536w" sizes="(max-width: 1600px) 100vw, 1600px" />															</div>
												</div>
												<div className="elementor-element elementor-element-6d490e62 elementor-widget elementor-widget-heading" data-id="6d490e62" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
													<div className="elementor-widget-container">
														<h2 className="elementor-heading-title elementor-size-default">Your Small Party Solution!</h2>				</div>
												</div>
												<div className="elementor-element elementor-element-10448ca8 elementor-widget elementor-widget-heading" data-id="10448ca8" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
													<div className="elementor-widget-container">
														<h2 className="elementor-heading-title elementor-size-default">A Proud Venture of TSR Catering &amp; Events</h2>				</div>
												</div>
												<div className="elementor-element elementor-element-79493341 elementor-widget__width-inherit elementor-widget elementor-widget-wpr-elementor-template" data-id="79493341" data-element_type="widget" data-e-type="widget" data-widget_type="wpr-elementor-template.default">
													<div className="elementor-widget-container">

<div data-elementor-type="section" data-elementor-id="2992" className="elementor elementor-2992">
															<section className="elementor-section elementor-top-section elementor-element elementor-element-39992dac elementor-section-boxed elementor-section-height-default elementor-section-height-default wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no" data-id="39992dac" data-element_type="section" data-e-type="section">
																<div className="elementor-container elementor-column-gap-default">
																	<div className="elementor-column elementor-col-16 elementor-top-column elementor-element elementor-element-2a58a633" data-id="2a58a633" data-element_type="column" data-e-type="column">
																		<div className="elementor-widget-wrap elementor-element-populated">
																			<div className="elementor-element elementor-element-56188b52 wpr-flip-box-animation-flip wpr-flip-box-animation-3d-yes wpr-flip-box-anim-direction-right wpr-flip-box-front-align-center wpr-flip-box-back-align-center elementor-widget elementor-widget-wpr-flip-box" data-id="56188b52" data-element_type="widget" data-e-type="widget" data-widget_type="wpr-flip-box.default">
																				<div className="elementor-widget-container">

																					<div className="wpr-flip-box" data-trigger="hover">

																						<div className="wpr-flip-box-item wpr-flip-box-front wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">


																								<h3 className="wpr-flip-box-title">Affordable &amp; Premium</h3>





																							</div>
																						</div>

																						<div className="wpr-flip-box-item wpr-flip-box-back wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">

																								<a className="wpr-flip-box-link" href="#"></a>


																								<h3 className="wpr-flip-box-title">
																									Restaurant-quality food without breaking the bank.						</h3>





																							</div>
																						</div>
																					</div>

																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="elementor-column elementor-col-16 elementor-top-column elementor-element elementor-element-72f76e54" data-id="72f76e54" data-element_type="column" data-e-type="column">
																		<div className="elementor-widget-wrap elementor-element-populated">
																			<div className="elementor-element elementor-element-6f3f4845 wpr-flip-box-animation-flip wpr-flip-box-animation-3d-yes wpr-flip-box-anim-direction-right wpr-flip-box-front-align-center wpr-flip-box-back-align-center elementor-widget elementor-widget-wpr-flip-box" data-id="6f3f4845" data-element_type="widget" data-e-type="widget" data-widget_type="wpr-flip-box.default">
																				<div className="elementor-widget-container">

																					<div className="wpr-flip-box" data-trigger="hover">

																						<div className="wpr-flip-box-item wpr-flip-box-front wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">


																								<h3 className="wpr-flip-box-title">Multi-Cuisine Variety</h3>





																							</div>
																						</div>

																						<div className="wpr-flip-box-item wpr-flip-box-back wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">

																								<a className="wpr-flip-box-link" href="#"></a>


																								<h3 className="wpr-flip-box-title">
																									Indian, Continental, Mediterranean &amp; more by expert chefs.						</h3>





																							</div>
																						</div>
																					</div>

																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="elementor-column elementor-col-16 elementor-top-column elementor-element elementor-element-1dbd5eaf" data-id="1dbd5eaf" data-element_type="column" data-e-type="column">
																		<div className="elementor-widget-wrap elementor-element-populated">
																			<div className="elementor-element elementor-element-588e6b90 wpr-flip-box-animation-flip wpr-flip-box-animation-3d-yes wpr-flip-box-anim-direction-right wpr-flip-box-front-align-center wpr-flip-box-back-align-center elementor-widget elementor-widget-wpr-flip-box" data-id="588e6b90" data-element_type="widget" data-e-type="widget" data-widget_type="wpr-flip-box.default">
																				<div className="elementor-widget-container">

																					<div className="wpr-flip-box" data-trigger="hover">

																						<div className="wpr-flip-box-item wpr-flip-box-front wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">


																								<h3 className="wpr-flip-box-title">Safe &amp; Fresh</h3>





																							</div>
																						</div>

																						<div className="wpr-flip-box-item wpr-flip-box-back wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">

																								<a className="wpr-flip-box-link" href="#"></a>


																								<h3 className="wpr-flip-box-title">
																									21+ hygiene checks, no Dalda, no baking soda, sunflower oil cooking.						</h3>





																							</div>
																						</div>
																					</div>

																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="elementor-column elementor-col-16 elementor-top-column elementor-element elementor-element-191b8513" data-id="191b8513" data-element_type="column" data-e-type="column">
																		<div className="elementor-widget-wrap elementor-element-populated">
																			<div className="elementor-element elementor-element-6c9f6ddd wpr-flip-box-animation-flip wpr-flip-box-animation-3d-yes wpr-flip-box-anim-direction-right wpr-flip-box-front-align-center wpr-flip-box-back-align-center elementor-widget elementor-widget-wpr-flip-box" data-id="6c9f6ddd" data-element_type="widget" data-e-type="widget" data-widget_type="wpr-flip-box.default">
																				<div className="elementor-widget-container">

																					<div className="wpr-flip-box" data-trigger="hover">

																						<div className="wpr-flip-box-item wpr-flip-box-front wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">


																								<h3 className="wpr-flip-box-title">Ready-to-Serve Packs</h3>





																							</div>
																						</div>

																						<div className="wpr-flip-box-item wpr-flip-box-back wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">

																								<a className="wpr-flip-box-link" href="#"></a>


																								<h3 className="wpr-flip-box-title">
																									Food-grade, microwave-safe boxes.						</h3>





																							</div>
																						</div>
																					</div>

																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="elementor-column elementor-col-16 elementor-top-column elementor-element elementor-element-48590745" data-id="48590745" data-element_type="column" data-e-type="column">
																		<div className="elementor-widget-wrap elementor-element-populated">
																			<div className="elementor-element elementor-element-24a8e9b6 wpr-flip-box-animation-flip wpr-flip-box-animation-3d-yes wpr-flip-box-anim-direction-right wpr-flip-box-front-align-center wpr-flip-box-back-align-center elementor-widget elementor-widget-wpr-flip-box" data-id="24a8e9b6" data-element_type="widget" data-e-type="widget" data-widget_type="wpr-flip-box.default">
																				<div className="elementor-widget-container">

																					<div className="wpr-flip-box" data-trigger="hover">

																						<div className="wpr-flip-box-item wpr-flip-box-front wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">


																								<h3 className="wpr-flip-box-title">Buffet Upgrade</h3>





																							</div>
																						</div>

																						<div className="wpr-flip-box-item wpr-flip-box-back wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">

																								<a className="wpr-flip-box-link" href="#"></a>


																								<h3 className="wpr-flip-box-title">
																									Add an elegant buffet setup, if needed.						</h3>





																							</div>
																						</div>
																					</div>

																				</div>
																			</div>
																		</div>
																	</div>
																	<div className="elementor-column elementor-col-16 elementor-top-column elementor-element elementor-element-7dfc8dff" data-id="7dfc8dff" data-element_type="column" data-e-type="column">
																		<div className="elementor-widget-wrap elementor-element-populated">
																			<div className="elementor-element elementor-element-74f322c0 wpr-flip-box-animation-flip wpr-flip-box-animation-3d-yes wpr-flip-box-anim-direction-right wpr-flip-box-front-align-center wpr-flip-box-back-align-center elementor-widget elementor-widget-wpr-flip-box" data-id="74f322c0" data-element_type="widget" data-e-type="widget" data-widget_type="wpr-flip-box.default">
																				<div className="elementor-widget-container">

																					<div className="wpr-flip-box" data-trigger="hover">

																						<div className="wpr-flip-box-item wpr-flip-box-front wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">


																								<h3 className="wpr-flip-box-title">Perfect for small parties</h3>





																							</div>
																						</div>

																						<div className="wpr-flip-box-item wpr-flip-box-back wpr-anim-timing-ease-default">

																							<div className="wpr-flip-box-overlay"></div>

																							<div className="wpr-flip-box-content">

																								<a className="wpr-flip-box-link" href="#"></a>


																								<h3 className="wpr-flip-box-title">
																									stress-free, delicious, and beautifully managed!						</h3>





																							</div>
																						</div>
																					</div>

																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</section>
														</div>
														<span className="wpr-template-edit-btn" data-permalink="/?elementor_library=pmk-usp">Edit Template</span>				</div>
												</div>
												<div className="elementor-element elementor-element-7498ea8 elementor-widget__width-inherit elementor-widget elementor-widget-elementskit-heading" data-id="7498ea8" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
													<div className="elementor-widget-container">
														<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Pune’s Most Recommended for Luxury Meals by Kilo, KILO Catering, Gourmet Snack &amp; Meal Boxes, and Curated House Party Catering</h2></div></div>				</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-60756499 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="60756499" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-6e8c3f8d elementor-widget__width-initial elementor-widget elementor-widget-elementskit-heading" data-id="6e8c3f8d" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-heading.default">
												<div className="elementor-widget-container">
													<div className="ekit-wid-con"><div className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-"><h2 className="ekit-heading--title elementskit-section-title ">Our methodology is built for house parties, family gatherings, and curated at-home celebrations across Pune.</h2><div className="ekit_heading_separetor_wraper ekit_heading_elementskit-border-divider ekit-dotted"><div className="elementskit-border-divider ekit-dotted"></div></div></div></div>				</div>
											</div>
											<div className="elementor-element elementor-element-2d36448d e-grid e-con-full wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="2d36448d" data-element_type="container" data-e-type="container">
												<div className="elementor-element elementor-element-5c4c588f elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="5c4c588f" data-element_type="widget" data-e-type="widget" data-widget_type="icon-list.default">
													<div className="elementor-widget-container">
														<ul className="elementor-icon-list-items">
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-icon">
																	<svg aria-hidden="true" className="e-font-icon-svg e-fas-dot-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path></svg>						</span>
																<span className="elementor-icon-list-text">Rehearsal Dinners</span>
															</li>
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-icon">
																	<svg aria-hidden="true" className="e-font-icon-svg e-fas-dot-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path></svg>						</span>
																<span className="elementor-icon-list-text">Bridal Showers</span>
															</li>
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-icon">
																	<svg aria-hidden="true" className="e-font-icon-svg e-fas-dot-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path></svg>						</span>
																<span className="elementor-icon-list-text">Haldi</span>
															</li>
														</ul>
													</div>
												</div>
												<div className="elementor-element elementor-element-2a7d0474 elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list" data-id="2a7d0474" data-element_type="widget" data-e-type="widget" data-widget_type="icon-list.default">
													<div className="elementor-widget-container">
														<ul className="elementor-icon-list-items">
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-icon">
																	<svg aria-hidden="true" className="e-font-icon-svg e-fas-dot-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path></svg>						</span>
																<span className="elementor-icon-list-text">Bachelor/Bachelorette Parties</span>
															</li>
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-icon">
																	<svg aria-hidden="true" className="e-font-icon-svg e-fas-dot-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path></svg>						</span>
																<span className="elementor-icon-list-text">Prewedding Party</span>
															</li>
															<li className="elementor-icon-list-item">
																<span className="elementor-icon-list-icon">
																	<svg aria-hidden="true" className="e-font-icon-svg e-fas-dot-circle" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"></path></svg>						</span>
																<span className="elementor-icon-list-text">Post Wedding Get Together at home</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-6d20c273 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="6d20c273" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="e-con-inner">
												<div className="elementor-element elementor-element-ccd1894 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="ccd1894" data-element_type="container" data-e-type="container">
													<div className="elementor-element elementor-element-9c63080 e-grid e-con-full wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="9c63080" data-element_type="container" data-e-type="container">
														<div className="elementor-element elementor-element-782f9fa7 ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="782f9fa7" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
															<div className="elementor-widget-container">
																<div className="ekit-wid-con">        {/* link opening */}
																	{/* end link opening */}

																	<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																		<div className="elementskit-box-header">
																			<div className="elementskit-info-box-icon ">
																				<img decoding="async" width="2560" height="1707" src="/assets/images/03/CNC07032-scaled.jpg" className="attachment- size-" alt="" srcSet="/assets/images/03/CNC07032-scaled.jpg 2560w, /assets/images/03/CNC07032-300x200.jpg 300w, /assets/images/03/CNC07032-1024x683.jpg 1024w, /assets/images/03/CNC07032-768x512.jpg 768w, /assets/images/03/CNC07032-1536x1024.jpg 1536w, /assets/images/03/CNC07032-2048x1365.jpg 2048w" sizes="(max-width: 2560px) 100vw, 2560px" />                </div>
																		</div>
																		<div className="box-body">
																			<h3 className="elementskit-info-box-title">
																				Party Meals                 </h3>
																			<p>Menu
																			</p>
																			<div className="box-footer disable_hover_button">
																				<div className="btn-wraper">
																					<a>
																						EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																				</div>
																			</div>
																		</div>


																	</div>
																</div>				</div>
														</div>
														<div className="elementor-element elementor-element-3d19d511 ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="3d19d511" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
															<div className="elementor-widget-container">
																<div className="ekit-wid-con">        {/* link opening */}
																	{/* end link opening */}

																	<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																		<div className="elementskit-box-header">
																			<div className="elementskit-info-box-icon ">
																				<img loading="lazy" decoding="async" width="1920" height="1080" src="/assets/images/01/cooked-dish.jpg" className="attachment- size-" alt="" srcSet="/assets/images/01/cooked-dish.jpg 1920w, /assets/images/01/cooked-dish-300x169.jpg 300w, /assets/images/01/cooked-dish-1024x576.jpg 1024w, /assets/images/01/cooked-dish-768x432.jpg 768w, /assets/images/01/cooked-dish-1536x864.jpg 1536w" sizes="(max-width: 1920px) 100vw, 1920px" />                </div>
																		</div>
																		<div className="box-body">
																			<h3 className="elementskit-info-box-title">
																				Food by KILO                 </h3>
																			<p>Self Serve Combos


																			</p>
																			<div className="box-footer disable_hover_button">
																				<div className="btn-wraper">
																					<a className="elementskit-btn whitespace--normal" href="https://partymealsbykilo.petpooja.site/">
																						EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																				</div>
																			</div>
																		</div>


																	</div>
																</div>				</div>
														</div>
														<div className="elementor-element elementor-element-1eb44837 ekit-equal-height-disable elementor-widget elementor-widget-elementskit-icon-box" data-id="1eb44837" data-element_type="widget" data-e-type="widget" data-widget_type="elementskit-icon-box.default">
															<div className="elementor-widget-container">
																<div className="ekit-wid-con">        {/* link opening */}
																	{/* end link opening */}

																	<div className="elementskit-infobox text-center text-center icon-top-align elementor-animation-   ">
																		<div className="elementskit-box-header">
																			<div className="elementskit-info-box-icon ">
																				<img loading="lazy" decoding="async" width="1200" height="580" src="/assets/images/01/Barbecue-dish-item-1.jpg" className="attachment- size-" alt="" srcSet="/assets/images/01/Barbecue-dish-item-1.jpg 1200w, /assets/images/01/Barbecue-dish-item-1-300x145.jpg 300w, /assets/images/01/Barbecue-dish-item-1-1024x495.jpg 1024w, /assets/images/01/Barbecue-dish-item-1-768x371.jpg 768w" sizes="(max-width: 1200px) 100vw, 1200px" />                </div>
																		</div>
																		<div className="box-body">
																			<h3 className="elementskit-info-box-title">
																				Snack Box                 </h3>
																			<p>&amp; Plated Box Meals
																			</p>
																			<div className="box-footer disable_hover_button">
																				<div className="btn-wraper">
																					<a>
																						EXPLORE MENU                                         <i aria-hidden="true" className="icon icon-right-arrow"></i>                                    </a>
																				</div>
																			</div>
																		</div>


																	</div>
																</div>				</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="elementor-element elementor-element-625fce2c e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="625fce2c" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
											<div className="elementor-element elementor-element-1b987bc4 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="1b987bc4" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
												<div className="e-con-inner">
													<div className="elementor-element elementor-element-24689b25 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="24689b25" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
																												<EnquiryHeading widgetElementId="35e501aa" />

																												<EnquiryForm widgetElementId="30c4c884" />

													</div>
												</div>
											</div>
										</div>
									</div>



								</div>
							</div>
						</article>
					</main>
				</div>
			</div>
		</div>
	)
}

export default DeliveryServices

